import { LOGGER_LOG } from '../constants'

const LoggerMiddleware = () => next => (action) => {
    switch (action.type) {
        // Log whatever is sent our way to the console
        case LOGGER_LOG: {
            const result = next(action)
            console.info(action.payload)
            return result
        }

        default:
            return next(action)
    }
}

export default LoggerMiddleware



// WEBPACK FOOTER //
// ./src/middlewares/LoggerMiddleware.js